import { ThemeService } from './theme.service';
import { Injectable, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Location } from '@angular/common';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  constructor(private themeService: ThemeService, public location: Location, private themService: ThemeService) {}

  /**
   * Validação para saber se o obejto enviado esta vazio
   * @param objeto
   * Objeto a ser validado
   */
  isObjetoVazio(objeto = {}): boolean {
    return Object.keys(objeto).length === 0 && objeto.constructor === Object;
  }

  requireCheckboxValidator(minRequired = 1) {
    return function validate(formGroup: FormGroup) {
      let checked = 0;

      Object.keys(formGroup.controls).forEach((key) => {
        const control = formGroup.controls[key];

        if (control.value === true) {
          checked++;
        }
      });

      if (checked < minRequired) {
        return { requireOneCheckboxToBeChecked: true };
      }

      return null;
    };
  }

  paramsObjectToString(params: object) {
    return Object.keys(params).reduce((acc, curr, index) => {
      const param = `${curr}=${params[curr]}`;

      return (acc += index === 0 ? param : `&${param}`);
    }, '');
  }

  convertStringParamsToObject(search: string) {
    return JSON.parse(
      decodeURIComponent(
        '{"' + search.replace(/\+/g, ' ').replace(/"/g, '\\"').replace(/&/g, '", "').replace(/=/g, '":"') + '"}'
      )
    );
  }

  getUrlParams(url: string, separator: string = '?') {
    const index = url.indexOf(separator);

    if (index >= 0) {
      const params = url.substring(index + 1);
      return new URLSearchParams(params);
    }

    return new URLSearchParams();
  }

  formatarValorBr(valor: any, decimais: number = 2): string {
    return Number(valor).toLocaleString('de-DE', { minimumFractionDigits: decimais, maximumFractionDigits: decimais });
  }

  formatCurrency(value: any): number {
    let valor = value;
    if (String(value).includes(',')) {
      valor = String(value).replace(/\./g, '').replace(/\,/g, '.');
    }
    return Number(valor);
  }

  voltar(): void {
    this.location.back();
  }

  async gerarPdfComprovante(elementRef: ElementRef) {
    try {
      const element = elementRef.nativeElement;

      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        scrollY: -window.screenY,
      });
      const imgData = canvas.toDataURL('image/png');

      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      const pdfWitdh = canvasWidth * 0.264583;
      const pdfHeight = canvasHeight * 0.264583;

      const pdf = new jsPDF('p', 'mm', [pdfWitdh, pdfHeight]);

      pdf.addImage(imgData, 'PNG', 0, 0, pdfWitdh, pdfHeight);

      const base64PDF = pdf.output('datauristring').split(',')[1];

      if (this.themeService.getTheme().type === 'mobile') {
        if (window['nativeDocuments']) {
          await window['nativeDocuments'].showPdfWithBase64(base64PDF, 'comprovante');
        }

        if (window['documentsServiceBridge']) {
          await window['documentsServiceBridge'].showPDFWithBase64(base64PDF, 'comprovante');
        }
      } else {
        pdf.save('comprovante.pdf');
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  sanitizer(value: string) {
    try {
      let sanitized = '';
      if (typeof value !== 'string') {
        return '';
      }
      sanitized = value + '';
      sanitized = sanitized
        .toLowerCase()
        .replace(/\&/g, 'e')
        .replace(/\!/g, '')
        .replace(/\?/g, '')
        .replace(/^\s+/, '')
        .replace(/\,\s+/g, ',')
        .replace(/\:\s+/g, ':')
        .replace(/\.\s+/g, '.')
        .replace(/\s+/g, ' ')
        .replace(/\s+/g, '-')
        .replace(/[áàâãåäæª\u00e1\u00e0\u00e2\u00e3\u00e5\u00e4\u00e6\u00aa]/g, 'a')
        .replace(/[éèêëЄ€\u00e9\u00e8\u00ea\u00eb\u0404\u20ac]/g, 'e')
        .replace(/[íìîï\u00ed\u00ec\u00ee\u00ef]/g, 'i')
        .replace(/[\u00f3\u00f2\u00f4\u00f5\u00f6\u00f8]/g, 'o')
        .replace(/[º\u00ba]/g, 'o.')
        .replace(/[úùûü\u00fa\u00f9\u00fb\u00fc]/g, 'u')
        .replace(/[ç¢©\u00e7\u00a2\u00a9]/g, 'c')
        .replace(/_+/g, '-')
        .replace(/,/g, '-');
      return sanitized;
    } catch (e) {
      return '';
    }
  }
}
